import { DELETEOBJECTIVETASK_SUCCESS, DELETEOBJECTIVETASK_FAIL } from "../actionTypes";

const initialState = {
    user: null,
};

const deleteObjectiveTaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEOBJECTIVETASK_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEOBJECTIVETASK_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deleteObjectiveTaskReducer;
